import React from 'react';
import { Theme } from '../../ChatWidget/types';
import s from './Clouds.module.scss';

interface CloudsProps {
  theme: Theme;
}

export const Clouds = ({ theme }: CloudsProps) => {
  if (theme === 'dark') {
    return (
      <div className={s.container}>
        <svg>
          <clipPath id="cloud-side-clip" clipPathUnits="objectBoundingBox">
            <path d="M0.133,0.1 C0.042,0,0.01,-0.078,0.004,-0.129 C0,-0.166,0.054,-0.189,0.114,-0.186 C0.433,-0.173,0.986,-0.17,1,-0.167 C1,-0.162,0.88,0.698,0.88,0.744 C0.88,0.791,0.538,0.834,0.405,0.803 C0.272,0.772,0.399,0.457,0.405,0.388 C0.411,0.319,0.311,0.296,0.133,0.1"></path>
          </clipPath>
        </svg>

        <div className={s.cloudDarkLeft}>
          <div className={s.cloudDarkLeftInner}></div>
        </div>
        <div className={s.cloudDarkRight}>
          <div className={s.cloudDarkRightInner}></div>
        </div>
      </div>
    );
  } else {
    return (
      <div className={s.container}>
        <svg>
          <clipPath id="cloud-center-clip" clipPathUnits="objectBoundingBox">
            <path d="M0.853,0.696 C0.957,0.795,0.993,0.872,1,0.923 C1,0.963,0.967,0.986,0.929,0.988 C0.45,1,0.23,0.7,0.211,0.696 C0.186,0.691,0,0.104,0,0.058 C0,0.011,0.39,-0.031,0.542,0 C0.694,0.031,0.55,0.342,0.542,0.411 C0.535,0.479,0.649,0.502,0.853,0.696"></path>
          </clipPath>
        </svg>

        <div className={s.cloudLight}>
          <div className={s.cloudLightInner}></div>
        </div>
      </div>
    );
  }
};
